

<template>
  <CContainer>
    <h1>Partner info</h1>
    <p>{{partnerInfo}}</p>
    <h1>Respuestas automaticas</h1>
    <CDataTable
      responsive
      hover
      striped
      bordered
      small
      fixed
      :items="partnerReviewReplys"
      :fields="fields"
      :dark="dark"
      :items-per-page="10"
      column-filter
      sorter
      pagination
    >
    </CDataTable>
    <h1>Plantillas</h1>
    <CDataTable
      responsive
      hover
      striped
      bordered
      small
      fixed
      :items="partnerTemplates"
      :fields="fields"
      :dark="dark"
      :items-per-page="10"
      column-filter
      sorter
      pagination
    >
    </CDataTable>
    <h1>Alarm WOrds</h1>
    <CDataTable
      responsive
      hover
      striped
      bordered
      small
      fixed
      :items="partnerAlarmWords"
      :fields="fields"
      :dark="dark"
      :items-per-page="10"
      column-filter
      sorter
      pagination
    >
    </CDataTable>

  </CContainer>
</template>

</script>
<script>
  import "vue2-datepicker/scss/index.scss";
  import store from "../../store";

  const items = [];

  export default {
    name: "PartnerDetail",
    props: ["itemID","location"],
    computed: {

    },
    components: {
    },

    data() {
      return {
        isLoading:true,
        partner_id:Number(this.$route.params.itemID),
        partnerInfo: [],
        partnerReviewReplys: [],
        partnerTemplates: [],
        partnerAlarmWords: [],
        language: '',
        auto_reply_review: '',
        auto_reply_review_datetime: '',
        disabled: '',
        alarm_system: '',     
        isLoadingPartner:false,
        edit:false,
      };
    },
    async mounted() {
      let partner_id=Number(this.$route.params.itemID);
      if(partner_id!=="" ||partner_id!==undefined ){
        //console.log("itemID",Number(this.$route.params.itemID));
        this.partner_id=Number(this.$route.params.itemID);
        await this.getPartnerInfo();
        await this.getPartnerReviewReplys();
        await this.getPartnerTemplates();
        await this.getPartnerAlarmWords();
      }
    },
    methods: {
      getImage(pic){

        return "data:image/png;base64,"+pic
      },
      async getPartnerInfo(){
        var partner_info=[];
        this.isLoadingPartner = true;
        var partner_id=Number(this.$route.params.itemID);
        var payload ={
          partner_id: partner_id
        }
        await store.dispatch("getPartnerInfo", payload).then(() => {
          partner_info = store.getters.getPartnerInfo;
          // console.log('PARTNER INFO ==>>>>>>> ', partner_info)
          if(partner_info.length>0)
            this.partnerInfo = partner_info[0];
            this.language = partner_info[0].language;
            this.auto_reply_review = partner_info[0].auto_reply_review;
            this.auto_reply_review_datetime = partner_info[0].auto_reply_review_datetime;
            this.disabled = partner_info[0].disabled;
            this.alarm_system = partner_info[0].alarm_system;

          return;
        });
        this.isLoadingPartner = false;

      },
      async getPartnerReviewReplys(){
        var partnerReviewReplys_data=[];
        this.isLoadingPartner = true;
        var partner_id=Number(this.$route.params.itemID);
        var payload ={
          partner_id: partner_id
        }
        await store.dispatch("getPartnerReviewReplys", payload).then(() => {
          partnerReviewReplys_data = store.getters.getPartnerReviewReplys;
          // console.log('PARTNER INFO ==>>>>>>> ', partnerReviewReplys_data)
          if(partnerReviewReplys_data.length>0)
            this.partnerReviewReplys = partnerReviewReplys_data;

          return;
        });
        this.isLoadingPartner = false;

      },
      async getPartnerTemplates(){
        var partnerTemplates=[];
        this.isLoadingPartner = true;
        var partner_id=Number(this.$route.params.itemID);
        var payload ={
          partner_id: partner_id
        }
        await store.dispatch("getPartnerTemplates", payload).then(() => {
          partnerTemplates = store.getters.getPartnerTemplates;
          // console.log('PARTNER INFO ==>>>>>>> ', partnerTemplates)
          if(partnerTemplates.length>0)
            this.partnerTemplates = partnerTemplates;

          return;
        });
        this.isLoadingPartner = false;

      },
      async getPartnerAlarmWords(){
        var partnerTemplates=[];
        this.isLoadingPartner = true;
        var partner_id=Number(this.$route.params.itemID);
        var payload ={
          partner_id: partner_id
        }
        await store.dispatch("getPartnerAlarmWords", payload).then(() => {
          partnerTemplates = store.getters.getPartnerAlarmWords;
          // console.log('PARTNER INFO ==>>>>>>> ', partnerTemplates)
          if(partnerTemplates.length>0)
            this.partnerAlarmWords = partnerTemplates;

          return;
        });
        this.isLoadingPartner = false;

      },
      async updatePartnerData(){
      // console.log("==========> test update direction", this.row_data);
        var payload ={
          "language": this.language,
          "auto_reply_review": this.auto_reply_review,
          "auto_reply_review_datetime":this.auto_reply_review_datetime,
          "disabled":this.disabled,
          "alarm_system":this.alarm_system,
          row_data:Number(this.$route.params.itemID)

        }
      //console.log("payload", payload);
        await store.dispatch("updatePartnerData",payload).then(() => {
          var nombre = store.getters.updatePartnerData;
            //console.log("store nombre update", nombre);
            // this.getlocation();
            // this.modalDirection=false;
        })
        return;

      },
      async onEdit(){
        console.log("language", this.language);
      //console.log("locality", this.locality);
      //console.log("administrative_area", this.administrative_area);
      //console.log("region_code", this.region_code);
      //console.log("postal_code", this.postal_code);
        this.updatePartnerData();
        await this.getPartnerInfo();
        this.editmethod();

      },
    },
  };
</script>